import {PropsWithChildren} from 'react';
import {colors} from 'patient-ping-remedy/packages/theme';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import Badge from 'patient-ping-remedy/packages/badge';
import {MessageThreadSummary} from '@/api/dto/message';
import MessageThreadUnits from '@/components/pages/messages/details/MessageThreadUnits';
import MessageThreadMembers from '@/components/pages/messages/details/MessageThreadMembers';
import MessageThreadAttachments from '@/components/pages/messages/details/MessageThreadAttachments';
import {Wrapper} from '@/components/pages/messages/details/MessageThreadDetails.styles';

type Props = PropsWithChildren & {
  messageThreadSummary?: MessageThreadSummary;
  concise?: boolean;
  interactive?: boolean;
}

export default function MessageThreadDetails({ messageThreadSummary, concise, interactive, children }: Props) {
  return (
    <Wrapper>
      {messageThreadSummary?.muted && (
        <Badge backgroundColor={colors.gray1} textColor={colors.charcoal} className="badge">
          <Icon iconClass={ICONS['bell-slash']} iconSize="lg" />
          Muted
        </Badge>
      )}
      {children}
      <MessageThreadUnits messageThreadSummary={messageThreadSummary} concise={concise} />
      <MessageThreadMembers messageThreadSummary={messageThreadSummary} concise={concise} />
      <MessageThreadAttachments messageThreadSummary={messageThreadSummary} concise={concise} interactive={interactive} />
    </Wrapper>
  );
}
